import React from 'react';
import InteractionDetailModal from '../InteractionDetailModal';

// Cell renderer for topic name with link
const TopicNameRenderer = (params) => {
  const [open, setOpen] = React.useState(false);

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setOpen(true);
  }

  return (
    <>
      <span onClick={handleOpenModal} className="tw-text-blue-600 tw-cursor-pointer">
        {params.value}
      </span>

      <InteractionDetailModal
        open={open}
        setOpen={setOpen}
        topic={params.data}
      />
    </>
  );
};

export default TopicNameRenderer;